import { Component, Host, h, ComponentInterface } from '@stencil/core';

@Component({
  tag: 'vds-slide',
  styleUrl: 'vds-slide.scss'
})
export class VdsSlide implements ComponentInterface {
  render() {
    return (
      <Host
        class={{
          'swiper-slide': true,
          'swiper-zoom-container': true,
        }}
      ></Host>
    );
  }
}
